import { render, staticRenderFns } from "./ProjectCameraInfo.vue?vue&type=template&id=070f61fe&scoped=true&"
import script from "./ProjectCameraInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectCameraInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCameraInfo.vue?vue&type=style&index=0&id=070f61fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f61fe",
  null
  
)

export default component.exports